import React, { FunctionComponent } from "react";
import "./style.scss";
import img_feature1 from "../../asserts/images/feature1.png";
import img_feature2 from "../../asserts/images/feature2.png";
import img_feature3 from "../../asserts/images/feature3.png";
import img_feature4 from "../../asserts/images/feature4.png";
import img_feature5 from "../../asserts/images/feature5.png";
import img_feature6 from "../../asserts/images/feature6.png";
import img_feature7 from "../../asserts/images/feature7.png";
import img_feature8 from "../../asserts/images/feature8.png";
import img_feature9 from "../../asserts/images/feature9.png";

import icon_tt from "../../asserts/svg/time_tracking.svg";
import icon_w from "../../asserts/svg/window.svg";
import icon_sch from "../../asserts/svg/scheduler.svg";
import icon_n from "../../asserts/svg/notification.svg";
import icon_l from "../../asserts/svg/list.svg";
import icon_lng from "../../asserts/svg/language.svg";
import icon_c from "../../asserts/svg/code.svg";
import icon_calendar from "../../asserts/svg/calendar.svg";

import point_img from "../../asserts/svg/robot_point_3.svg";

const FeaturesPage: FunctionComponent = () => {
    return <div className="FeaturesPage">
        <div className="block gray">
            <div className="content">
                <div>
                    <img className="slide" src={img_feature1} alt="Introducing Timinator" />
                </div>
                <div>
                    <img className="slide mobile" src={img_feature1} alt="Introducing Timinator" />
                    <div className="titleGr">Introducing Timinator</div>
                    <div className="descriptionGr">
                        Timinator - the all-in-one tool that lets you focus on creating while we handle time tracking for you!
                    </div>
                    <div className="buttons">
                        <a target="_blank"  rel="noreferrer" href="https://processing.timinator.app/slack/install">
                            <button>
                                <div className="image"/>
                                <div className="text">Add to Slack</div>
                            </button>
                        </a>
                    </div>
                </div>
            </div>
        </div>

        <div className="block">
            <div className="content">
                <div>
                    <div className="img"><img src={icon_tt} alt="Time tracking" /></div>
                    <div className="title">Time tracking</div>
                    <img className="slide mobile" src={img_feature2} alt="Time tracking" />
                    <div className="description mt16">
                        With Timinator, you can easily track your working hours, absence hours, and even overtime hours with just a few clicks. Our user-friendly interface allows for easy editing and the use of shortcuts to save you even more time.
                    </div>
                </div>
                <div>
                    <img className="slide" src={img_feature2} alt="Time tracking" />
                </div>
            </div>
        </div>

        <div className="block">
            <div className="content">
                <div>
                    <img className="slide" src={img_feature3} alt="Admin console" />
                </div>
                <div>
                    <div className="img"><img src={icon_w} alt="Admin console" /></div>
                    <div className="title">Admin console</div>
                    <img className="slide mobile" src={img_feature3} alt="Admin console" />
                    <div className="description">
                        Our powerful admin console lets you manage clients, projects, employees, roles, project types, shift types, and absence types with ease.
                    </div>
                </div>
            </div>
        </div>

        <div className="block">
            <div className="content">
                <div>
                    <div className="img"><img src={icon_sch} alt="Recurring shifts" /></div>
                    <div className="title">Recurring shifts</div>
                    <img className="slide mobile" src={img_feature4} alt="Recurring shifts" />
                    <div className="description">
                        And with our unique feature for recurring shifts, you can trust your employees and make everyone's lives easier by scheduling shifts to track only exceptions like sick days or vacations.
                    </div>
                </div>
                <div>
                    <img className="slide" src={img_feature4} alt="Recurring shifts" />
                </div>
            </div>
        </div>

        <div className="block">
            <div className="content">
                <div>
                    <img className="slide" src={img_feature5} alt="Configurable reminders" />
                </div>
                <div>
                    <div className="img"><img src={icon_n} alt="Configurable reminders" /></div>
                    <div className="title">Configurable reminders</div>
                    <img className="slide mobile" src={img_feature5} alt="Configurable reminders" />
                    <div className="description">
                        Stay on top of your schedule with our configurable reminders - set the time that suits you best and we'll make sure to notify you accordingly.
                    </div>
                </div>
            </div>
        </div>

        <div className="block">
            <div className="content">
                <div>
                    <div className="img"><img src={icon_l} alt="Reports" /></div>
                    <div className="title">Reports</div>
                    <img className="slide mobile" src={img_feature6} alt="Reports" />
                    <div className="description">
                        With our detailed reporting capabilities, you can easily generate reports by employee, project, or day, and export them as files.
                    </div>
                </div>
                <div>
                    <img className="slide" src={img_feature6} alt="Reports" />
                </div>
            </div>
        </div>

        <div className="block">
            <div className="content">
                <div>
                    <img className="slide" src={img_feature7} alt="Vacations" />
                </div>
                <div>
                    <div className="img"><img src={icon_lng} alt="Vacations" /></div>
                    <div className="title">Vacations</div>
                    <img className="slide mobile" src={img_feature7} alt="Vacations" />
                    <div className="description">
                        Planning a vacation? Request and approve time off with ease, notify your team or everyone, and even generate reports to stay organized.
                    </div>
                </div>
            </div>
        </div>

        <div className="block">
            <div className="content">
                <div>
                    <div className="img"><img src={icon_c} alt="Integrations" /></div>
                    <div className="title">Integrations</div>
                    <img className="slide mobile" src={img_feature8} alt="Integrations" />
                    <div className="description">
                        And with our Zoho invoice integration, you can streamline your billing process like never before.
                    </div>
                </div>
                <div>
                    <img className="slide" src={img_feature8} alt="Integrations" />
                </div>
            </div>
        </div>

        <div className="block">
            <div className="content">
                <div>
                    <img className="slide" src={img_feature9} alt="Working calendars" />
                </div>
                <div>
                    <div className="img"><img src={icon_calendar} alt="Working calendars" /></div>
                    <div className="title">Working calendars</div>
                    <img className="slide mobile" src={img_feature9} alt="Working calendars" />
                    <div className="description">
                        Say goodbye to manual holiday tracking, as we seamlessly integrate with various calendars to automatically keep tabs on public holidays. Customize the calendar to suit your specific needs. And if you have a distributed team, fear not, as you can effortlessly assign different calendars to each team member.
                    </div>
                </div>
            </div>
        </div>

        <div className="FarewellBlock">
            <div className="content">
                <div className="point">
                    <img src={point_img} alt="robot point" />
                </div>
                <div className="farewell">
                    Don't let time tracking consume your time and energy. Try Timinator now and see how easy, effortless, and unobtrusive it can be.
                </div>
                <div className="buttons">
                    <a target="_blank"  rel="noreferrer" href="https://processing.timinator.app/slack/install">
                        <button>
                            <div className="image"/>
                            <div className="text">Add to Slack</div>
                        </button>
                    </a>
                </div>
            </div>
        </div>

    </div>
}

export default FeaturesPage;